import type { SVGProps } from 'react';

const LightbulbIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M9 18h6" />
    <path d="M10 22h4" />
    <path d="M12 2a7 7 0 0 0-4 12.714V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.286A7 7 0 0 0 12 2z" />
  </svg>
);

export const INTERSTITIAL_ICON_REGISTRY: Record<string, React.FC<SVGProps<SVGSVGElement>>> = {
  lightbulb: LightbulbIcon,
};
